import React, {useMemo} from 'react';
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {hashHistory} from "react-router";

import {cancelWizardGroupsChanges} from "../WizardSetup/wizardActions";
import {postDiscounts} from "./discountsAsyncActions";



const DiscountsFooter = (props) => {

  const {discountSections, cancelWizardGroupsChanges, postDiscounts, discountSectionsBackup, discountsReceived} = props;

  const updateItemCount = useMemo(() => {
    if (!discountsReceived) {
      return 0
    }
    const moreSectionsIn = discountSectionsBackup.length > discountSections.length
      ? discountSectionsBackup
      : discountSections.length > discountSectionsBackup.length
        ? discountSections
        : discountSectionsBackup;
    const opposite = moreSectionsIn === discountSectionsBackup ? discountSections : discountSectionsBackup;
    return moreSectionsIn.reduce((count, section) => {
      const sameSection = opposite.find(sec => sec.id === section.id);
      if (!sameSection || Object.keys(section).some(key => {
        return key !== "discounts" && (section[key] !== sameSection[key])
      })) {
        return count + 1;
      }
      section.discounts.forEach((discount, discountIndex) => {
        if (!sameSection.discounts[discountIndex] || Object.keys(discount).some(key => {
          return discount[key] !== sameSection.discounts[discountIndex][key]
        })) {
          count = count + 1;
        }
      });
      return count
    }, 0)
  }, [discountSections, discountSectionsBackup, discountsReceived]);

  const handleFooterCancelClick = () => {
    if (updateItemCount) {
      cancelWizardGroupsChanges("discounts");
    } else {
      hashHistory.push("/");
    }
  }

  const handleFooterSaveClick = async () => {
    const saved = await postDiscounts();
    console.log("saved", saved);
  }

  const saveDisabled = false;

  return (
    <div className="app-content-footer app-content-footer--fixed">
      <div className="app-content-footer__buttons">
        <button className="ui-button ui-button--blue" onClick={handleFooterCancelClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.cancel"/>
          </span>
        </button>
        <button className={"ui-button ui-button--green ui-button--large" + (saveDisabled ? " ui-button--disabled" : "")}
                disabled={saveDisabled}
                onClick={handleFooterSaveClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.save"/>
          </span>
          {updateItemCount ? (
            <span className="updateCount updateCount--new" title="Unsaved item count">{updateItemCount}</span>
          ) : null}
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {workSheetsActiveIndex, discountSections, discountSectionsBackup, discountsReceived} = store.discountsState;
  return {
    discountSections,
    workSheetsActiveIndex,
    discountSectionsBackup,
    discountsReceived,
  };
};

const mapDispatchToProps = {
  cancelWizardGroupsChanges,
  postDiscounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsFooter);
